module.exports = __webpack_public_path__ + "assets/img/37_388_big.16b2756c.jpg";